/* BREDA — Scroll reveal via IntersectionObserver */
(function () {
  const els = document.querySelectorAll('.breda-reveal');

  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.04, rootMargin: '0px 0px -20px 0px' }
  );

  els.forEach(function (el) {
    // Elements already above the fold (user scrolled past) → show immediately
    const rect = el.getBoundingClientRect();
    if (rect.bottom < window.innerHeight * 0.1) {
      el.classList.add('is-visible');
    } else {
      observer.observe(el);
    }
  });
})();
